import {
  Box,
  Stack,
  Tab,
  IconButton,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { StyledBox, StyledTabs } from "./styles";
import CardPlan from "components/CardPlan";
import { iPlanCategory } from "data/interfaces/plans";
import { isMobile } from "react-device-detect";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useState } from "react";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Stack
      spacing={{ xs: 1, sm: 2, md: 2, lg: 1, xl: 1 }}
      direction={{
        xs: "column",
        sm: "column",
        md: "row",
        lg: "row",
        xl: "row",
      }}
      useFlexGap
      flexWrap="wrap"
      role="tabpanel"
      justifyContent="center"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </Stack>
  );
}

type PropsTabsPlans = {
  typePlan: number;
  typePersonId: number;
  allPlans: iPlanCategory[];
  onChangePlan: (event: any) => void;
};

export default function TabsPlans({
  allPlans,
  typePlan,
  onChangePlan,
  typePersonId,
}: PropsTabsPlans) {
  const theme = useTheme();
  const isMdScreen = useMediaQuery(theme.breakpoints.only("md"));
  const isLgUpScreen = useMediaQuery(theme.breakpoints.up("lg"));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("md"));

  const [startIndex, setStartIndex] = useState(0);

  const handleChangePlan = (
    _event: React.SyntheticEvent,
    newValue: string
  ) => {
    onChangePlan(newValue);
    setStartIndex(0); // reset scroll on tab change
  };

  return (
    <Stack>
      <Box display="flex" justifyContent={"center"}>
        <StyledTabs
          value={typePlan}
          onChange={handleChangePlan}
          variant="scrollable"
          allowScrollButtonsMobile={!isMobile}
          scrollButtons
        >
          {allPlans[typePersonId].plans.map((plan, index) => (
            <Tab
              wrapped={false}
              key={index}
              value={index}
              label={plan.title}
            />
          ))}
        </StyledTabs>
      </Box>

      <StyledBox display="flex" justifyContent={"center"}>
        {allPlans[typePersonId].plans.map((plans, index) => (
          <TabPanel key={index} value={typePlan} index={index}>
            {isLargeScreen ? (
              (() => {
                const length = plans.plans.length;
                const visibleCount = isLgUpScreen ? 3 : isMdScreen ? 2 : length;

                const getVisiblePlans = () => {
                  if (startIndex + visibleCount <= length) {
                    return plans.plans.slice(
                      startIndex,
                      startIndex + visibleCount
                    );
                  } else {
                    return [
                      ...plans.plans.slice(startIndex),
                      ...plans.plans.slice(
                        0,
                        (startIndex + visibleCount) % length
                      ),
                    ];
                  }
                };

                const handleNext = () => {
                  setStartIndex((prev) => (prev + visibleCount) % length);
                };

                const handlePrev = () => {
                  setStartIndex(
                    (prev) => (prev - visibleCount + length) % length
                  );
                };

                return (
                  <Box display="flex" alignItems="center" gap={2}>
                    {length > visibleCount && (
                      <IconButton sx={{ color: "white" }} onClick={handlePrev}>
                        <ArrowBackIosIcon />
                      </IconButton>
                    )}
                    <Box display="flex" gap={2}>
                      {getVisiblePlans().map((plan, i) => (
                        <CardPlan key={i} plan={plan} />
                      ))}
                    </Box>

                    {length > visibleCount && (
                      <IconButton sx={{ color: "white" }} onClick={handleNext}>
                        <ArrowForwardIosIcon />
                      </IconButton>
                    )}
                  </Box>
                );
              })()
            ) : (
              plans.plans.map((plan, i) => <CardPlan key={i} plan={plan} />)
            )}
          </TabPanel>
        ))}
      </StyledBox>
    </Stack>
  );
}